/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */

import React, { useCallback } from 'react';
import { AddIcon, DeleteIcon } from 'tdesign-icons-react';
import { Button } from 'tdesign-react';

import { IFormItemProps } from '@/components';
import { IScoreRule } from '@/interface';

import Item from './item';
import styles from './styles/index.module.less';


interface IFormArrayProps {
  fieldsConfig: IFormItemProps[];
  form: any;
  repeatConfig?: {
    [key: string]: IFormItemProps[];
  };
}

export const CustomScoreRules: React.FC<
{
  fieldname: string;
  config: any;
  errors: { [key: string]: any };
  getFieldDecorator: any;
  value: IScoreRule[];
  onChange: (value: IScoreRule[]) => void;
  disabled?: boolean;
} & IFormArrayProps
> = (props) => {
  const {
    value = [],
    onChange,
    disabled = false,
  } = props;

  const handleClick1 = useCallback(() => {
    onChange([...value, {
      rangeMin: 0,
      rangeMax: 100,
      rule: '',
    }]);
  }, [onChange, value]);

  return (
    <div className={styles.root}>
      <div style={{ marginBottom: 16 }}>
        <Button disabled={disabled}
          size='small' icon={<AddIcon />} onClick={handleClick1}>新增分数规则</Button>
      </div>
      {value.map((item, idx) => <div key={idx} className={styles.item}>
        <Item
          value={item}
          disabled={disabled}
          onChange={(val: IScoreRule) => onChange([...value.slice(0, idx), val, ...value.slice(idx + 1)])} />
        <Button
          theme='default'
          disabled={disabled}
          icon={<DeleteIcon />}
          className={styles.delete}
          onClick={() => onChange([...value.slice(0, idx), ...value.slice(idx + 1)])}>
        </Button>
      </div>)}
    </div>
  );
};
